import { render, staticRenderFns } from "./TablaProductosGrid.vue?vue&type=template&id=a9355728&scoped=true"
import script from "./TablaProductosGrid.vue?vue&type=script&lang=js"
export * from "./TablaProductosGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9355728",
  null
  
)

export default component.exports